import { useTheme } from 'styled-components';
import { whiteSpace } from '../../../theme';
import { ButtonProps } from '../../../types';
import { Icon, IconName } from '../../Icon';
import * as MoreStyled from './More.styled';

interface Props extends ButtonProps {
  onClick?: () => void;
  icon?: IconName;
}

export const Button = (props: Props) => {
  const { children, icon, onClick } = props;
  const theme = useTheme();

  return (
    <MoreStyled.ButtonWrapper onClick={onClick}>
      <MoreStyled.ButtonOutline>
        <MoreStyled.ButtonBody>
          {icon && (
            <Icon
              style={{ marginRight: whiteSpace['6'] }}
              height={32}
              width={32}
              className="base-icon"
              fill={theme.color.ui100}
              name={icon}
            />
          )}
          <MoreStyled.ButtonLabel>{children}</MoreStyled.ButtonLabel>
          <MoreStyled.IconLeft />
        </MoreStyled.ButtonBody>
      </MoreStyled.ButtonOutline>
    </MoreStyled.ButtonWrapper>
  );
};
